import { HashRouter, useLocation } from "react-router-dom";
import App from "../App";
import React, { Suspense, lazy } from "react"
import { Route, Routes } from "react-router-dom"

import LoadingRoute from "../components/LoadingRoute";

// 引入页面
const Home = lazy(() => import("../views/Home"))
const Layouts = lazy(() => import("../Layouts"))
const Error = lazy(() => import("../views/Error"))
const GoodsManage = lazy(() => import("../views/GoodsManage"))
// const UsersManage = lazy(() => import("../views/UsersManage"))
const OrderManage = lazy(() => import("../views/OrderManage"))
const PledgeManage = lazy(() => import("../views/pledgeManage"))
const DistributeManage = lazy(() => import("../views/DistributeManage"))
const WorkManage = lazy(() => import("../views/WorkManage"))
const AddGoods = lazy(() => import("../views/AddGoods"))
const ModifyGoods = lazy(() => import("../views/ModifyGoods"))
const DivideshopManage = lazy(() => import("../views/DivideshopManage"))
const ClassifyManage = lazy(() => import("../views/ClassifyManage"))
const StaffManage = lazy(() => import("../views/StaffManage"))
const GoodsDetails = lazy(() => import("../views/GoodsDetails"))
const ShopGroup = lazy(() => import("../views/shopGroup"))
const SettingOrder = lazy(() => import("../views/SettingOrder"))
const OperatorsManager = lazy(() => import("../views/OperatorsManage"))
const CityManage = lazy(() => import("../views/CityManage"))
const DownloadFile = lazy(() => import("../views/DownloadFile"))
const HouseManage = lazy(() => import("../views/HouseManage"))
const QrManage = lazy(() => import("../views/qrManage"))
const QrDetail = lazy(() => import("../views/qrDetail"))
const QrList = lazy(() => import("../views/qrList"))
// import Home from "../pages/Home";


const Router = () => {
    return (
        <HashRouter>
            <Suspense fallback={<div><LoadingRoute /></div>}>
                <Routes>
                    <Route path="" element={<App></App>}></Route>
                    <Route path="/" element={<Layouts />}>
                        <Route path="/home" element={<Home />}></Route>
                        <Route path="/goods/m/:n/:s" element={<GoodsManage />}></Route>
                        <Route path="/order/m/:n/:s/:key" element={<OrderManage />}></Route>
                    <Route path="/order/m" element={<OrderManage />}></Route>
                    <Route path="/pledge/m" element={<PledgeManage />}></Route>
                        <Route path="/distribute/m" element={<DistributeManage />}></Route>
                        <Route path="/work/m/:n/:s" element={<WorkManage />}></Route>
                        <Route path="/add/g" element={<AddGoods />}></Route>
                        <Route path="/modify/g/:id" element={<ModifyGoods />}></Route>
                        <Route path="/divide/s/:n/:s" element={<DivideshopManage />}></Route>
                        <Route path="/classify/m/:n/:s" element={<ClassifyManage />}></Route>
                        <Route path="/staff/m/:id/:n/:s/:name" element={<StaffManage />}></Route>
                        <Route path="/good/d/:id" element={<GoodsDetails />}></Route>
                        <Route path="/shop/g/:n/:s" element={<ShopGroup />}></Route>
                        <Route path="/setting/order" element={<SettingOrder />}></Route>
                        <Route path="/operators/m" element={<OperatorsManager />}></Route>
                        <Route path="/city/m" element={<CityManage />}></Route>
                        <Route path="/downfile" element={<DownloadFile />}></Route>
                        <Route path="/house/s/:n/:s" element={<HouseManage />}></Route>
                        <Route path="/qr/m/:n/:s" element={<QrManage />}></Route>
                        <Route path="/qr/detail/:batchId/:n/:s" element={<QrDetail />} />
						<Route path="/qr/list/:n/:s" element={<QrList />} />
                    </Route>
                    <Route path="*" element={<Error />}></Route>
                </Routes>
            </Suspense>
        </HashRouter>
    )
}

export default Router;
